import React from 'react';
import { styled } from '@glitz/react';
import { Text, ResponsiveSize } from 'Shared/SharedComponents/atoms/Typography';
import { StyleOrStyleArray } from '@glitz/type';
import * as style from 'Shared/Style';

type TagsType = {
  tags: string[];
  marginTop?: string;
  marginBottom?: string;
  nrToDisplay?: number;
  readMoreLabel?: string;
  readMoreClick?: () => void;
};

const Wrap = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
})

const Tag = styled.span({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: { x: '12px', y: '7px' },
  backgroundColor: style.colors.backgrounds.white,
  fontSize: '12px',
  fontWeight: 800,
  letterSpacing: '.14em',
  textTransform: 'uppercase',
  borderRadius: '3px',
  boxShadow: '0 2px 6px rgba(0, 0, 0, .06)'
})

const ReadMoreLabel = styled(Text, {
  cursor: 'pointer',
  color: style.colors.grey.dark,
  ':hover': {
    color: style.colors.black.default,
  }
})

function ProductTags(props: TagsType) {
  const tags = props.nrToDisplay ? props.tags && props.tags.slice(0, props.nrToDisplay) : props.tags && props.tags;

  return (
    <Wrap
      css={{
        ...(props.marginTop && {
          marginTop: props.marginTop
        }),
        ...(props.marginBottom && {
          marginBottom: props.marginBottom
        })
      }}
    >
      {tags && tags.map((tag, i) => (
        <BgTag key={i}>{tag}</BgTag>
      ))}
      {props.readMoreLabel && (
        <ReadMoreLabel
          upperCase
          fontSize={ResponsiveSize.D14_M14}
          onClick={props.readMoreClick}
        >
          {props.readMoreLabel}
        </ReadMoreLabel>
      )}
    </Wrap>
  );
}

export const BgTag = ({ children, css }: { children: React.ReactNode; css?: StyleOrStyleArray }) => (
  <Tag css={{ ...css }}>
    {children}
  </Tag>
);

export default ProductTags;
